import { render, staticRenderFns } from "./addMapping.vue?vue&type=template&id=a73d0622"
import script from "./addMapping.vue?vue&type=script&lang=js"
export * from "./addMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports